import { MasterDetailListEntry } from '@sdbn/common';
import { ParameterType } from './parameter-type.enum';

export class SupplementaryEquipment implements MasterDetailListEntry {
    id: number;
    dictionaryKey: string;
    translatedLabel: string;
    deleted = false;

    constructor(tool: any) {
        this.id = tool.id;
        this.dictionaryKey = tool.dictionaryKey;
    }

    public get listTitle(): string {
        return this.translatedLabel;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public get groupIdentifier(): String {
      return null;
    }

    public get childs() : Array<MasterDetailListEntry> {
      return null;
    }

}
